// GENERATED by scripts/gen-wording.ts from docs/EMAIL-WORDING-2026-10.md (the Director's wording, approved 1 Oct 2026).
// Do not edit by hand: change the document and run `npx tsx scripts/gen-wording.ts`.

export interface GeneratedWordingPart {
  subject: string;
  heading: string | null;
  body: string;
}

export const DIRECTOR_WORDING_SOURCE = "docs/EMAIL-WORDING-2026-10.md";

export const DIRECTOR_WORDING: Readonly<Record<string, { en: GeneratedWordingPart; es: GeneratedWordingPart | null }>> = {
  "HK_PLEASE_CONFIRM": {
    "en": {
      "subject": "Your cleaning visit on [AppointmentDate] — please confirm",
      "heading": "Your cleaning visit — please confirm",
      "body": "Greetings, [TenantPreferredName].\n\nYour next housekeeping visit is scheduled. Here are the details:\n\n> Day: [AppointmentDate]\n> Time: [VisitWindow] ([ServicePeriod])\n> Apartment: [UnitNumber]\n\nPlease let us know you'll be home. One tap is all it takes.\n\nOr call the office at [OfficePhone]. We're glad to help.\n\nWarm regards,\nThe Housekeeping Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Su visita de limpieza el [AppointmentDate]: por favor confirme",
      "heading": "Su visita de limpieza: por favor confirme",
      "body": "Saludos, [TenantPreferredName].\n\nSu próxima visita de limpieza ya está programada. Estos son los datos:\n\n> Día: [AppointmentDate]\n> Hora: [VisitWindow] ([ServicePeriod])\n> Apartamento: [UnitNumber]\n\nPor favor díganos que estará en casa. Basta con un toque.\n\nO llame a la oficina al [OfficePhone]. Con gusto le ayudamos.\n\nUn cordial saludo,\nEl equipo de limpieza\nAssociated Blind Foundation"
    }
  },
  "HK_SEE_YOU": {
    "en": {
      "subject": "See you on [AppointmentDate]",
      "heading": "You're all set",
      "body": "Greetings, [TenantPreferredName].\n\nThank you — your housekeeping visit is confirmed.\n\n> Day: [AppointmentDate]\n> Time: [VisitWindow] ([ServicePeriod])\n> Apartment: [UnitNumber]\n\nThe crew will knock when they arrive. If anything changes before then, use the buttons below or call the office at [OfficePhone].\n\nWarm regards,\nThe Housekeeping Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Nos vemos el [AppointmentDate]",
      "heading": "Todo listo",
      "body": "Saludos, [TenantPreferredName].\n\nGracias: su visita de limpieza está confirmada.\n\n> Día: [AppointmentDate]\n> Hora: [VisitWindow] ([ServicePeriod])\n> Apartamento: [UnitNumber]\n\nEl equipo tocará la puerta al llegar. Si algo cambia antes, use los botones de abajo o llame a la oficina al [OfficePhone].\n\nUn cordial saludo,\nEl equipo de limpieza\nAssociated Blind Foundation"
    }
  },
  "HK_REMINDER": {
    "en": {
      "subject": "Reminder: your cleaning visit is [AppointmentDate]",
      "heading": "A quick reminder",
      "body": "Greetings, [TenantPreferredName].\n\nYour housekeeping visit is coming up and we haven't heard back from you yet.\n\n> Day: [AppointmentDate]\n> Time: [VisitWindow] ([ServicePeriod])\n> Apartment: [UnitNumber]\n\nPlease tap a button below so the crew knows to expect you — or call the office at [OfficePhone].\n\nWarm regards,\nThe Housekeeping Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Recordatorio: su visita de limpieza es el [AppointmentDate]",
      "heading": "Un breve recordatorio",
      "body": "Saludos, [TenantPreferredName].\n\nSu visita de limpieza se acerca y todavía no sabemos de usted.\n\n> Día: [AppointmentDate]\n> Hora: [VisitWindow] ([ServicePeriod])\n> Apartamento: [UnitNumber]\n\nPor favor toque un botón de abajo para que el equipo sepa que lo espera, o llame a la oficina al [OfficePhone].\n\nUn cordial saludo,\nEl equipo de limpieza\nAssociated Blind Foundation"
    }
  },
  "HK_RESCHEDULED": {
    "en": {
      "subject": "Your cleaning visit is now on [AppointmentDate]",
      "heading": "Your visit has a new day",
      "body": "Greetings, [TenantPreferredName].\n\nYour housekeeping visit has been moved. Here is the new time:\n\n> Day: [AppointmentDate]\n> Time: [VisitWindow] ([ServicePeriod])\n> Apartment: [UnitNumber]\n\nPlease confirm the new day below, or call the office at [OfficePhone] if it doesn't work for you.\n\nWarm regards,\nThe Housekeeping Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Su visita de limpieza ahora es el [AppointmentDate]",
      "heading": "Su visita tiene un nuevo día",
      "body": "Saludos, [TenantPreferredName].\n\nSu visita de limpieza fue cambiada de día. Esta es la nueva hora:\n\n> Día: [AppointmentDate]\n> Hora: [VisitWindow] ([ServicePeriod])\n> Apartamento: [UnitNumber]\n\nPor favor confirme el nuevo día abajo, o llame a la oficina al [OfficePhone] si no le conviene.\n\nUn cordial saludo,\nEl equipo de limpieza\nAssociated Blind Foundation"
    }
  },
  "HK_CANCELLED": {
    "en": {
      "subject": "Your cleaning visit on [AppointmentDate] is cancelled",
      "heading": "Your visit is cancelled",
      "body": "Greetings, [TenantPreferredName].\n\nYour housekeeping visit on [AppointmentDate] has been cancelled.\n\nWhen you're ready for a new day, call the office at [OfficePhone] and we'll find one together.\n\nWarm regards,\nThe Housekeeping Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Su visita de limpieza del [AppointmentDate] está cancelada",
      "heading": "Su visita está cancelada",
      "body": "Saludos, [TenantPreferredName].\n\nSu visita de limpieza del [AppointmentDate] fue cancelada.\n\nCuando quiera un nuevo día, llame a la oficina al [OfficePhone] y lo buscamos juntos.\n\nUn cordial saludo,\nEl equipo de limpieza\nAssociated Blind Foundation"
    }
  },
  "HK_ENTRY_PERMISSION": {
    "en": {
      "subject": "Your cleaning visit on [AppointmentDate] — may the team come in while you're out?",
      "heading": "We need your permission",
      "body": "Greetings, [TenantPreferredName].\n\nWe understand you won't be home for your housekeeping visit on [AppointmentDate], apartment [UnitNumber].\n\nOur team can enter your apartment when you're not there only with your clear permission. Please choose one of the buttons below.\n\nThis permission is for this one visit only. If we don't hear from you, the team will not go in.\n\nQuestions? Call the office at [OfficePhone].\n\nWarm regards,\nThe Housekeeping Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Su visita de limpieza del [AppointmentDate]: ¿puede entrar el equipo mientras usted no está?",
      "heading": "Necesitamos su permiso",
      "body": "Saludos, [TenantPreferredName].\n\nEntendemos que usted no estará en casa para su visita de limpieza del [AppointmentDate], apartamento [UnitNumber].\n\nNuestro equipo solo puede entrar a su apartamento cuando usted no está si usted lo autoriza claramente. Por favor elija uno de los botones de abajo.\n\nEste permiso es solo para esta visita. Si no sabemos de usted, el equipo no entrará.\n\n¿Preguntas? Llame a la oficina al [OfficePhone].\n\nUn cordial saludo,\nEl equipo de limpieza\nAssociated Blind Foundation"
    }
  },
  "HK_NOTE": {
    "en": {
      "subject": "A note from the Housekeeping Program",
      "heading": "A note from the office",
      "body": "Greetings, [TenantPreferredName].\n\n[Message]\n\nIf you have any questions, call the office at [OfficePhone].\n\n[StaffName]\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Una nota del programa de limpieza",
      "heading": "Una nota de la oficina",
      "body": "Saludos, [TenantPreferredName].\n\n[Message]\n\nSi tiene alguna pregunta, llame a la oficina al [OfficePhone].\n\n[StaffName]\nAssociated Blind Foundation"
    }
  },
  "HK_PACKET": {
    "en": {
      "subject": "Welcome to the Selis Manor Housekeeping Program",
      "heading": "Welcome",
      "body": "Greetings, [TenantPreferredName].\n\nWelcome to the Housekeeping Program. We're glad to have you.\n\nYour welcome packet is attached. It explains how visits are scheduled, what the crew does on a visit, and how to reach us. Keep it somewhere handy.\n\nYou'll get an email before each visit with a button to confirm. If email isn't easy for you, that's fine — we'll call.\n\nWelcome aboard,\nThe Housekeeping Team\nAssociated Blind Foundation · [OfficePhone]"
    },
    "es": {
      "subject": "Bienvenido/a al programa de limpieza de Selis Manor",
      "heading": "Bienvenido/a",
      "body": "Saludos, [TenantPreferredName].\n\nBienvenido/a al programa de limpieza. Nos alegra tenerle con nosotros.\n\nAdjuntamos su paquete de bienvenida. Explica cómo se programan las visitas, qué hace el equipo en cada visita y cómo comunicarse con nosotros. Guárdelo a la mano.\n\nAntes de cada visita recibirá un correo con un botón para confirmar. Si el correo no le resulta fácil, no hay problema: le llamaremos.\n\nBienvenido/a,\nEl equipo de limpieza\nAssociated Blind Foundation · [OfficePhone]"
    }
  },
  "TENANT_FEEDBACK": {
    "en": {
      "subject": "How was your visit on [AppointmentDate]?",
      "heading": "How did we do?",
      "body": "Greetings, [TenantPreferredName].\n\nThank you for welcoming the crew into your home on [AppointmentDate].\n\nWe'd like to know how it went. The form takes about two minutes. If something was wrong, there's a place to tell us, and it goes straight to the Director.\n\nOr call the office at [OfficePhone] — we're always happy to listen.\n\nWarm regards,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "¿Cómo fue su visita del [AppointmentDate]?",
      "heading": "¿Cómo lo hicimos?",
      "body": "Saludos, [TenantPreferredName].\n\nGracias por recibir al equipo en su hogar el [AppointmentDate].\n\nNos gustaría saber cómo fue. El formulario toma unos dos minutos. Si algo estuvo mal, hay un espacio para contarnos, y llega directamente al Director.\n\nO llame a la oficina al [OfficePhone]; siempre estamos dispuestos a escuchar.\n\nUn cordial saludo,\nAssociated Blind Foundation"
    }
  },
  "DOC_COPY": {
    "en": {
      "subject": "Your copy of the [DocumentTitle]",
      "heading": "Your copy",
      "body": "Greetings, [TenantPreferredName].\n\nHere is your copy of the [DocumentTitle], as reviewed with you in the office. Please keep it for your records.\n\n[Details]\n\nQuestions? Call the office at [OfficePhone].\n\nWarm regards,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Su copia de [DocumentTitle]",
      "heading": "Su copia",
      "body": "Saludos, [TenantPreferredName].\n\nAquí tiene su copia de [DocumentTitle], tal como se revisó con usted en la oficina. Guárdela para su archivo.\n\n[Details]\n\n¿Preguntas? Llame a la oficina al [OfficePhone].\n\nUn cordial saludo,\nAssociated Blind Foundation"
    }
  },
  "TENANT_PARTNER_NOTICE": {
    "en": {
      "subject": "Your volunteer for [Activity] on [Date]",
      "heading": "You have a volunteer",
      "body": "Greetings, [TenantPreferredName].\n\nGood news — a volunteer is confirmed for your [Activity].\n\n> Day: [Date]\n> Time: [Time]\n> Meet: in the Selis Manor lobby\n> Your volunteer: [VolunteerFirst]\n\nIf anything changes, call the office at [OfficePhone].\n\nWarm regards,\nThe Companion & Wellness Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Su voluntario para [Activity] el [Date]",
      "heading": "Ya tiene voluntario",
      "body": "Saludos, [TenantPreferredName].\n\nBuenas noticias: hay un voluntario confirmado para su [Activity].\n\n> Día: [Date]\n> Hora: [Time]\n> Lugar de encuentro: el vestíbulo de Selis Manor\n> Su voluntario: [VolunteerFirst]\n\nSi algo cambia, llame a la oficina al [OfficePhone].\n\nUn cordial saludo,\nEl equipo de Companion & Wellness\nAssociated Blind Foundation"
    }
  },
  "EVENT_INVITE": {
    "en": {
      "subject": "You're invited: [EventName], [Date]",
      "heading": "You're invited",
      "body": "Greetings, [TenantPreferredName].\n\nPlease join us for [EventName].\n\n> Day: [Date]\n> Time: [Time]\n> Where: [Place]\n\n[Details]\n\nLet us know if you're coming with the buttons below, or call the office at [OfficePhone] and we'll add your name.\n\nWe hope to see you there,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Está invitado/a: [EventName], [Date]",
      "heading": "Está invitado/a",
      "body": "Saludos, [TenantPreferredName].\n\nLe invitamos a [EventName].\n\n> Día: [Date]\n> Hora: [Time]\n> Dónde: [Place]\n\n[Details]\n\nDíganos si viene con los botones de abajo, o llame a la oficina al [OfficePhone] y anotamos su nombre.\n\nEsperamos verle allí,\nAssociated Blind Foundation"
    }
  },
  "EVENT_REMINDER": {
    "en": {
      "subject": "Reminder: [EventName] is [Date]",
      "heading": "See you soon",
      "body": "Greetings, [TenantPreferredName].\n\nA friendly reminder — [EventName] is coming up.\n\n> Day: [Date]\n> Time: [Time]\n> Where: [Place]\n\nIf you can no longer make it, please call the office at [OfficePhone] so someone else can have the spot.\n\nSee you there,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Recordatorio: [EventName] es el [Date]",
      "heading": "Nos vemos pronto",
      "body": "Saludos, [TenantPreferredName].\n\nUn recordatorio amistoso: [EventName] se acerca.\n\n> Día: [Date]\n> Hora: [Time]\n> Dónde: [Place]\n\nSi ya no puede asistir, por favor llame a la oficina al [OfficePhone] para que otra persona pueda tomar el lugar.\n\nNos vemos allí,\nAssociated Blind Foundation"
    }
  },
  "EVENT_RAFFLE_WINNER": {
    "en": {
      "subject": "Good news about [EventName]",
      "heading": "Your name was drawn",
      "body": "Greetings, [TenantPreferredName].\n\nYour name was drawn in the raffle for [EventName] on [Date]. Congratulations!\n\nPlease call the office at [OfficePhone] to confirm your spot. If we don't hear from you in a few days, we'll call you.\n\nWarm regards,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Buenas noticias sobre [EventName]",
      "heading": "Su nombre salió en la rifa",
      "body": "Saludos, [TenantPreferredName].\n\nSu nombre salió en la rifa de [EventName] del [Date]. ¡Felicidades!\n\nPor favor llame a la oficina al [OfficePhone] para confirmar su lugar. Si no sabemos de usted en unos días, le llamaremos.\n\nUn cordial saludo,\nAssociated Blind Foundation"
    }
  },
  "VOL_WELCOME": {
    "en": {
      "subject": "Welcome — please complete your volunteer registration",
      "heading": "Welcome to the team",
      "body": "Hi [FirstName],\n\nThank you for your interest in volunteering at Selis Manor with the Associated Blind Foundation.\n\nThe next step is a short registration — about ten minutes. It asks about you, the services you would like to help with, an emergency contact and your availability, and it includes the volunteer waiver.\n\nOnce it is done, we will reach out about next steps.\n\nWarm regards,\n\nElijah Hobbs\nFoundation Director\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Bienvenido/a: por favor complete su registro de voluntario",
      "heading": "Bienvenido/a al equipo",
      "body": "Hola [FirstName]:\n\nGracias por su interés en ser voluntario/a en Selis Manor con la Associated Blind Foundation.\n\nEl siguiente paso es un registro corto, de unos diez minutos. Le pregunta sobre usted, los servicios en los que le gustaría ayudar, un contacto de emergencia y su disponibilidad, e incluye la exención de responsabilidad del voluntario.\n\nCuando lo termine, nos comunicaremos con usted sobre los próximos pasos.\n\nCordialmente,\n\nElijah Hobbs\nFoundation Director\nAssociated Blind Foundation"
    }
  },
  "VOL_SIGNED_UP": {
    "en": {
      "subject": "You're registered — thank you",
      "heading": "You're registered",
      "body": "Hi [FirstName],\n\nThank you for completing your registration. You signed up for: [ServicesSelected].\n\nWhat happens next:\n- Reading and Lessons: the office matches you with a tenant.\n- Event and activity support: you'll get the next invitation.\n\n[CompanionNotice]\n\nThe Volunteer Quick Start is attached — one page with the essentials. Your signed waiver is on file.\n\nWarm regards,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Ya está registrado/a: gracias",
      "heading": "Ya está registrado/a",
      "body": "Hola [FirstName]:\n\nGracias por completar su registro. Se inscribió para: [ServicesSelected].\n\nLo que sigue:\n- Lectura y clases: la oficina le asigna un inquilino.\n- Apoyo en eventos y actividades: recibirá la próxima invitación.\n\n[CompanionNotice]\n\nAdjuntamos la Guía rápida del voluntario: una página con lo esencial. Su exención firmada quedó en archivo.\n\nUn cordial saludo,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_QUICK_START": {
    "en": {
      "subject": "Your Volunteer Quick Start",
      "heading": "Your Quick Start",
      "body": "Hi [FirstName],\n\nThe Volunteer Quick Start is attached — your first outing, on one page. When in doubt, call the office at [OfficePhone].\n\nWarm regards,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Su Guía rápida del voluntario",
      "heading": "Su Guía rápida",
      "body": "Hola [FirstName]:\n\nAdjuntamos la Guía rápida del voluntario: su primera salida, en una página. Si tiene dudas, llame a la oficina al [OfficePhone].\n\nUn cordial saludo,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_AVAILABILITY": {
    "en": {
      "subject": "Please update your availability",
      "heading": "Your availability",
      "body": "Hi [FirstName],\n\nPlease click the button below to update your availability.\n\nThank you,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Por favor actualice su disponibilidad",
      "heading": "Su disponibilidad",
      "body": "Hola [FirstName]:\n\nPor favor haga clic en el botón de abajo para actualizar su disponibilidad.\n\nGracias,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_CONFIRM_INFO": {
    "en": {
      "subject": "Please confirm your volunteer information",
      "heading": "A quick check-in",
      "body": "Hi [FirstName],\n\nWe've moved to a new scheduling system. Please take a minute to confirm your name, phone, email, the services you'd like to help with, and when you're usually free. If we don't have your signed waiver on file, it's included.\n\nThank you for volunteering with us,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Por favor confirme su información de voluntario",
      "heading": "Una breve verificación",
      "body": "Hola [FirstName]:\n\nPasamos a un nuevo sistema de horarios. Por favor tome un minuto para confirmar su nombre, teléfono, correo, los servicios en los que quiere ayudar y cuándo suele estar libre. Si no tenemos su exención firmada en archivo, está incluida.\n\nGracias por ser voluntario/a con nosotros,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_REQUEST_ONE_TIME": {
    "en": {
      "subject": "[Activity] on [Date] at [Time] — can you help?",
      "heading": "A tenant needs a hand",
      "body": "Hi [FirstName],\n\nA tenant would like help with [Activity].\n\n> Day: [Date]\n> Time: [Time]\n> Meet: in the Selis Manor lobby\n\nIt's first come, first served — the first volunteer to press the button gets it, and the office confirms with you. If it's already taken, you'll see that right away.\n\nThank you,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "[Activity] el [Date] a las [Time]: ¿puede ayudar?",
      "heading": "Un inquilino necesita una mano",
      "body": "Hola [FirstName]:\n\nUn inquilino necesita ayuda con [Activity].\n\n> Día: [Date]\n> Hora: [Time]\n> Lugar de encuentro: el vestíbulo de Selis Manor\n\nEs por orden de llegada: el primer voluntario que pulse el botón se queda con la salida, y la oficina lo confirma con usted. Si ya fue tomada, lo verá de inmediato.\n\nGracias,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_REQUEST_CONSISTENT": {
    "en": {
      "subject": "A regular [Activity] — are you available?",
      "heading": "A regular volunteer is needed",
      "body": "Hi [FirstName],\n\nA tenant is looking for a regular volunteer for [Activity], starting [Date] at [Time], and then at the same time each week.\n\nIf that works for you, press \"Yes, I'm available\". If a different time would suit you better, press \"Propose another time\" and we'll check with the tenant.\n\nThank you,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Un/a [Activity] regular: ¿está disponible?",
      "heading": "Se necesita un voluntario regular",
      "body": "Hola [FirstName]:\n\nUn inquilino busca un voluntario regular para [Activity], a partir del [Date] a las [Time], y luego a la misma hora cada semana.\n\nSi le funciona, pulse \"Sí, estoy disponible\". Si le conviene otra hora, pulse \"Proponer otra hora\" y lo consultamos con el inquilino.\n\nGracias,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_CONFIRMATION": {
    "en": {
      "subject": "You're matched: [Activity] on [Date] at [Time]",
      "heading": "You're matched",
      "body": "Hi [FirstName],\n\nThank you — you're confirmed for [Activity].\n\n> Day: [Date]\n> Time: [Time]\n> Meet: in the Selis Manor lobby, 135 West 23rd Street\n> Where you're going: [Place]\n\nWalking directions are below, and the Quick Start is attached. Please check in with ABF staff at the front desk when you arrive. If something comes up, call the office at [OfficePhone] as early as you can.\n\nThank you,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Asignación confirmada: [Activity] el [Date] a las [Time]",
      "heading": "Quedó asignado/a",
      "body": "Hola [FirstName]:\n\nGracias: quedó confirmado/a para [Activity].\n\n> Día: [Date]\n> Hora: [Time]\n> Lugar de encuentro: el vestíbulo de Selis Manor, 135 West 23rd Street\n> A dónde va: [Place]\n\nAbajo están las indicaciones para llegar a pie, y adjuntamos la Guía rápida. Al llegar, preséntese con el personal de ABF en la recepción. Si surge algo, llame a la oficina al [OfficePhone] lo antes posible.\n\nGracias,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_REMINDER": {
    "en": {
      "subject": "Tomorrow: [Activity] at [Time]",
      "heading": "See you tomorrow",
      "body": "Hi [FirstName],\n\nA reminder that you're volunteering tomorrow.\n\n> Day: [Date]\n> Time: [Time]\n> Meet: in the Selis Manor lobby\n\nPlease press Confirm so the tenant knows you're coming. Directions are below and the Quick Start is attached.\n\nThank you,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Mañana: [Activity] a las [Time]",
      "heading": "Nos vemos mañana",
      "body": "Hola [FirstName]:\n\nLe recordamos que mañana será voluntario/a.\n\n> Día: [Date]\n> Hora: [Time]\n> Lugar de encuentro: el vestíbulo de Selis Manor\n\nPor favor pulse Confirmar para que el inquilino sepa que viene. Las indicaciones están abajo y adjuntamos la Guía rápida.\n\nGracias,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_OUTING_INTEREST": {
    "en": {
      "subject": "Group outing to [Place], [Date] — can you join us?",
      "heading": "Group outing",
      "body": "Hi [FirstName],\n\nWe're taking a group to [Place].\n\n> Day: [Date]\n> Time: [Time]\n> Meet: in the Selis Manor lobby\n\nIf you can help guide the group, press \"I accept — I will be there\". The spots fill in the order people press.\n\nThank you,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Salida en grupo a [Place], [Date]: ¿nos acompaña?",
      "heading": "Salida en grupo",
      "body": "Hola [FirstName]:\n\nLlevaremos un grupo a [Place].\n\n> Día: [Date]\n> Hora: [Time]\n> Lugar de encuentro: el vestíbulo de Selis Manor\n\nSi puede ayudar a guiar al grupo, pulse \"Acepto — ahí estaré\". Los lugares se llenan en el orden en que se pulsa.\n\nGracias,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_OUTING_REMINDER": {
    "en": {
      "subject": "Tomorrow: group outing to [Place]",
      "heading": "See you tomorrow",
      "body": "Hi [FirstName],\n\nA reminder of tomorrow's group outing to [Place] — meet in the Selis Manor lobby at [Time] on [Date]. Please check in with ABF staff at the front desk. The Quick Start is attached.\n\nThank you,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Mañana: salida en grupo a [Place]",
      "heading": "Nos vemos mañana",
      "body": "Hola [FirstName]:\n\nLe recordamos la salida en grupo de mañana a [Place]: nos reunimos en el vestíbulo de Selis Manor a las [Time] el [Date]. Preséntese con el personal de ABF en la recepción. Adjuntamos la Guía rápida.\n\nGracias,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_COMPLETION": {
    "en": {
      "subject": "How did [Activity] go?",
      "heading": "Thank you — one more minute",
      "body": "Hi [FirstName],\n\nThank you for [Activity] on [Date]. Five short questions below — they take a minute and help us keep everyone safe and well.\n\nWith appreciation,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "¿Cómo fue [Activity]?",
      "heading": "Gracias: un minuto más",
      "body": "Hola [FirstName]:\n\nGracias por [Activity] el [Date]. Cinco preguntas cortas abajo; toman un minuto y nos ayudan a cuidar a todos.\n\nCon aprecio,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "INT_HK_INCIDENT": {
    "en": {
      "subject": "Incident · Apt [UnitNumber] · [AppointmentDate]",
      "heading": "Incident report — Housekeeping",
      "body": "An incident was reported during the housekeeping visit at apartment [UnitNumber] on [AppointmentDate].\n\n[Details]\n\nThis memo is confidential. The full report and any photos are in the visit's folder."
    },
    "es": null
  },
  "INT_UNIT_SAFETY_ALERT": {
    "en": {
      "subject": "Unit condition · Apt [UnitNumber] · [AppointmentDate]",
      "heading": "Unit condition report",
      "body": "Dear Management Team,\n\n[Details]\n\nThe photos are in the visit's folder.\n\nThank you,\nAssociated Blind Foundation"
    },
    "es": null
  },
  "INT_STAFF_NOTE": {
    "en": {
      "subject": "About [TenantName] · Apt [UnitNumber]",
      "heading": "Staff note",
      "body": "[Message]\n\n[StaffName]"
    },
    "es": null
  },
  "INT_ENTRY_PERMISSION_COPY": {
    "en": {
      "subject": "Entry permission · Apt [UnitNumber] · [AppointmentDate]",
      "heading": "Entry permission recorded",
      "body": "The tenant of apartment [UnitNumber] gave permission for the housekeeping team to enter while they are out, for the visit on [AppointmentDate] only.\n\n[Details]"
    },
    "es": null
  },
  "INT_COMPANION_INCIDENT": {
    "en": {
      "subject": "CONFIDENTIAL · Companion incident · [Date]",
      "heading": "Incident report — Companion & Wellness",
      "body": "CONFIDENTIAL — for the Director and co-administrators only.\n\n[Details]"
    },
    "es": null
  },
  "VISIONS_REPORT": {
    "en": {
      "subject": "ABF Companion Program — VISIONS report for [Month]",
      "heading": null,
      "body": "Hello,\n\nAttached is the Companion Program roster and activity log for [Month] (Exhibit A), per our agreement.\n\nPlease let me know if anything needs adjusting.\n\n[StaffName]\nAssociated Blind Foundation"
    },
    "es": null
  },
  "TECH_TICKET": {
    "en": {
      "subject": "Tech ticket · [Date] at [Time] · [Place]",
      "heading": "New service ticket",
      "body": "Hi [FirstName],\n\nYou have a tech support appointment.\n\n> Day: [Date]\n> Time: [Time]\n> Where: [Place]\n> Tenant: [TenantPreferredName]\n> Help with: [Details]\n\nOpen the ticket to see the full description. Press Arrived when you start and Close out when you finish.\n\nAssociated Blind Foundation · [OfficePhone]"
    },
    "es": null
  },
  "TECH_BOOKED": {
    "en": {
      "subject": "Your computer help appointment on [Date]",
      "heading": "Help is on the way",
      "body": "Greetings, [TenantPreferredName].\n\nWe've booked time for you with our technology helper.\n\n> Day: [Date]\n> Time: [VisitWindow]\n> Where: [Place]\n> Your helper: [VolunteerFirst]\n\nPlease have the device you need help with ready. Confirm below, or call the office at [OfficePhone].\n\nWarm regards,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Su cita de ayuda con la computadora el [Date]",
      "heading": "La ayuda está en camino",
      "body": "Saludos, [TenantPreferredName].\n\nLe reservamos un tiempo con nuestro asistente de tecnología.\n\n> Día: [Date]\n> Hora: [VisitWindow]\n> Dónde: [Place]\n> Su asistente: [VolunteerFirst]\n\nPor favor tenga listo el aparato con el que necesita ayuda. Confirme abajo, o llame a la oficina al [OfficePhone].\n\nUn cordial saludo,\nAssociated Blind Foundation"
    }
  },
  "TECH_REMINDER": {
    "en": {
      "subject": "Today: your computer help appointment, [VisitWindow]",
      "heading": "Today's the day",
      "body": "Greetings, [TenantPreferredName].\n\nYour technology helper, [VolunteerFirst], is coming today [VisitWindow], [Place]. Please have your device ready. If you need to change it, call the office at [OfficePhone].\n\nWarm regards,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Hoy: su cita de ayuda con la computadora, [VisitWindow]",
      "heading": "Hoy es el día",
      "body": "Saludos, [TenantPreferredName].\n\nSu asistente de tecnología, [VolunteerFirst], viene hoy [VisitWindow], [Place]. Por favor tenga listo su aparato. Si necesita cambiarla, llame a la oficina al [OfficePhone].\n\nUn cordial saludo,\nAssociated Blind Foundation"
    }
  },
  "CLOSEOUT_REMINDER": {
    "en": {
      "subject": "Please close out: [Activity] · [Date]",
      "heading": "One thing left to do",
      "body": "Hi [FirstName],\n\nYour [Activity] on [Date] at [Time] hasn't been closed out yet. It takes about two minutes.\n\nPress the button below, or sign in to the portal and open Today.\n\nThank you,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Por favor cierre: [Activity] · [Date]",
      "heading": "Queda una cosa por hacer",
      "body": "Hola [FirstName]:\n\nSu [Activity] del [Date] a las [Time] todavía no se ha cerrado. Toma unos dos minutos.\n\nPulse el botón de abajo, o inicie sesión en el portal y abra Hoy.\n\nGracias,\nAssociated Blind Foundation"
    }
  },
  "VOL_ACTIVITY_REQUEST": {
    "en": {
      "subject": "Can you help at [EventName] on [Date]?",
      "heading": "We could use a hand",
      "body": "Hi [FirstName],\n\nWe're looking for volunteers to help with [EventName].\n\n> Day: [Date]\n> Time: [Time]\n> Where: [Place]\n> What you'd do: [Details]\n\nIf you can help, press \"I can help\" and the office will confirm. Please check in with ABF staff at the front desk when you arrive.\n\nThank you,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "¿Puede ayudar en [EventName] el [Date]?",
      "heading": "Nos vendría bien una mano",
      "body": "Hola [FirstName]:\n\nBuscamos voluntarios para ayudar en [EventName].\n\n> Día: [Date]\n> Hora: [Time]\n> Dónde: [Place]\n> En qué ayudaría: [Details]\n\nSi puede ayudar, pulse \"Puedo ayudar\" y la oficina lo confirmará. Al llegar, preséntese con el personal de ABF en la recepción.\n\nGracias,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_SCHEDULE_INVITE": {
    "en": {
      "subject": "Your usual days and times (the paragraph on a first confirmation)",
      "heading": null,
      "body": "You can also tell ABF the days and times you are usually free — it helps us match you with tenants. It is optional; you will still get every volunteer opportunity by email."
    },
    "es": {
      "subject": "Sus días y horas habituales (el párrafo de la primera confirmación)",
      "heading": null,
      "body": "También puede decirle a ABF los días y las horas en que suele estar libre: nos ayuda a encontrarle un inquilino. Es opcional; seguirá recibiendo por correo todas las oportunidades de voluntariado."
    }
  },
  "SURVEY_INVITE": {
    "en": {
      "subject": "A quick question for you: [EventName]",
      "heading": "We would like to hear from you",
      "body": "Greetings, [TenantPreferredName].\n\nWe have a short survey: [EventName].\n\n[Details]\n\nIt takes a minute or two. Press \"Answer the survey\" below.\n\nIf you would rather answer by phone, call the office at [OfficePhone].\n\nWarm regards,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Una pregunta rápida para usted: [EventName]",
      "heading": "Nos gustaría conocer su opinión",
      "body": "Saludos, [TenantPreferredName].\n\nTenemos una encuesta breve: [EventName].\n\n[Details]\n\nLe tomará uno o dos minutos. Pulse \"Responder la encuesta\" abajo.\n\nSi prefiere responder por teléfono, llame a la oficina al [OfficePhone].\n\nUn cordial saludo,\nAssociated Blind Foundation"
    }
  },
  "EVENT_VOLUNTEER_REQUEST": {
    "en": {
      "subject": "Can you help at [EventName], [Date]?",
      "heading": "We could use your help",
      "body": "Hello, [FirstName].\n\nWe are looking for volunteers for [EventName].\n\n> Day: [Date]\n> Time: [Time]\n> Where: [Place]\n\n[Details]\n\nPress \"I’m available\" if you can help, or \"Not this time\" if you can’t — either answer helps us plan. If we already have the volunteers we need, we will tell you and let you know if that changes.\n\nThank you,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "¿Puede ayudar en [EventName], [Date]?",
      "heading": "Nos vendría bien su ayuda",
      "body": "Hola, [FirstName].\n\nBuscamos voluntarios para [EventName].\n\n> Día: [Date]\n> Hora: [Time]\n> Dónde: [Place]\n\n[Details]\n\nPulse \"Estoy disponible\" si puede ayudar, o \"Esta vez no\" si no puede: cualquiera de las dos respuestas nos ayuda a planificar. Si ya tenemos los voluntarios que necesitamos, se lo diremos y le avisaremos si eso cambia.\n\nGracias,\nAssociated Blind Foundation"
    }
  },
  "EVENT_VOLUNTEER_MONTH": {
    "en": {
      "subject": "Volunteers needed: [EventName]",
      "heading": "Here is the month",
      "body": "Hello, [FirstName].\n\nThese are the events of [EventName] where we could use a volunteer:\n\n[Details]\n\nPress the button below and tell us, event by event, whether you are available. You can answer for one or for all of them, and change an answer later with the same button.\n\nThank you,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Se necesitan voluntarios: [EventName]",
      "heading": "Este es el mes",
      "body": "Hola, [FirstName].\n\nEstos son los eventos de [EventName] en los que nos vendría bien un voluntario:\n\n[Details]\n\nPulse el botón de abajo y díganos, evento por evento, si está disponible. Puede responder por uno o por todos, y cambiar una respuesta más tarde con el mismo botón.\n\nGracias,\nAssociated Blind Foundation"
    }
  },
  "EVENT_REMINDER_VOLUNTEER": {
    "en": {
      "subject": "Reminder about your volunteer event: [EventName], [Date]",
      "heading": "Your volunteer event",
      "body": "Hello, [FirstName].\n\nA reminder about your volunteer event: [EventName], [Date] at [Time], [Place].\n\n> Day: [Date]\n> Time: [Time]\n> Where: [Place]\n\nIf anything has changed, tap below.\n\nThank you for helping,\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Recordatorio de su evento como voluntario: [EventName], [Date]",
      "heading": "Su evento como voluntario",
      "body": "Hola, [FirstName].\n\nUn recordatorio de su evento como voluntario: [EventName], [Date] a las [Time], [Place].\n\n> Día: [Date]\n> Hora: [Time]\n> Dónde: [Place]\n\nSi algo ha cambiado, pulse abajo.\n\nGracias por ayudar,\nAssociated Blind Foundation"
    }
  },
  "VOL_READING_THANKS": {
    "en": {
      "subject": "Thank you for reading with us",
      "heading": "Thank you",
      "body": "Hi [FirstName],\n\nThank you so very much for reading with us.\n\nIf you have any questions or input, press the button below and leave a note. If not, you can ignore this email.\n\nWith appreciation,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Gracias por leer con nosotros",
      "heading": "Gracias",
      "body": "Hola [FirstName]:\n\nMuchas gracias por leer con nosotros.\n\nSi tiene preguntas o comentarios, pulse el botón de abajo y deje una nota. Si no, puede ignorar este correo.\n\nCon aprecio,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "VOL_READING_REPLY": {
    "en": {
      "subject": "About your note",
      "heading": "Thank you for your note",
      "body": "Hi [FirstName],\n\nThank you for your note.\n\n[Message]\n\nWith appreciation,\n[StaffName]\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Sobre su nota",
      "heading": "Gracias por su nota",
      "body": "Hola [FirstName]:\n\nGracias por su nota.\n\n[Message]\n\nCon aprecio,\n[StaffName]\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  },
  "EVENT_HELPER_THANKS": {
    "en": {
      "subject": "Thank you for helping at [EventName]",
      "heading": "Thank you",
      "body": "Hi [FirstName],\n\nThank you so much for helping at [EventName] on [Date]. We could not have done it without you.\n\nWith appreciation,\nThe Volunteer Team\nAssociated Blind Foundation"
    },
    "es": {
      "subject": "Gracias por ayudar en [EventName]",
      "heading": "Gracias",
      "body": "Hola [FirstName]:\n\nMuchas gracias por ayudar en [EventName] el [Date]. No lo habríamos logrado sin usted.\n\nCon aprecio,\nEl equipo de voluntarios\nAssociated Blind Foundation"
    }
  }
};
